import {PropsWithChildren} from "react";
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {PropertyMainInfoTexts} from "../../../features/properties/components/PropertyMainInfoTexts";
import {getModalPropertyLeadImageSrc} from "./utils/get_modal_property_lead_image_src";

interface IProps extends PropsWithChildren {
    property: IPropertyDetailDTO;
}

export const ModalPropertyLeadLayout = (props: IProps) => {
    const {property, children} = props;
    const imgSrc = getModalPropertyLeadImageSrc(property);

    return (
        <div className={innerWrap}>
            <div className={propertyWrapperStyle}>
                <div className={propertyCoverStyle}>
                    <Picture
                        className={pictureStyle}
                        sources={[{height: 80, width: 160, minWidthPX: 0, src: imgSrc}]}
                        alt={`${property.offer.name} - ${property.flat_number || property.building_number}`}
                    />
                </div>
                <div className={propertyInfoStyle}>
                    <PropertyMainInfoTexts property={property} />
                </div>
            </div>

            <div className={contentWrapperStyle}>{children}</div>
        </div>
    );
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    px: "1.5",
    py: "3",

    md: {
        height: "auto",
        p: "3",
        borderRadius: "1",
        width: "55rem"
    }
});

const propertyWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,

    sm: {
        flexDirection: "row"
    }
});

const propertyCoverStyle = css({
    width: "160px",
    height: "80px",
    md: {
        minWidth: "160px"
    }
});

const propertyInfoStyle = css({
    pr: "7",
    md: {
        pr: "4"
    }
});

const pictureStyle = css({
    justifyContent: "center",
    md: {
        mb: 3
    }
});

const contentWrapperStyle = css({
    mt: "4"
});
import {PropsWithChildren} from "react";
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {PropertyMainInfoTexts} from "../../../features/properties/components/PropertyMainInfoTexts";
import {getModalPropertyLeadImageSrc} from "./utils/get_modal_property_lead_image_src";

interface IProps extends PropsWithChildren {
    property: IPropertyDetailDTO;
}

export const ModalPropertyLeadLayout = (props: IProps) => {
    const {property, children} = props;
    const imgSrc = getModalPropertyLeadImageSrc(property);

    return (
        <div className={innerWrap}>
            <div className={propertyWrapperStyle}>
                <div className={propertyCoverStyle}>
                    <Picture
                        className={pictureStyle}
                        sources={[{height: 80, width: 160, minWidthPX: 0, src: imgSrc}]}
                        alt={`${property.offer.name} - ${property.flat_number || property.building_number}`}
                    />
                </div>
                <div className={propertyInfoStyle}>
                    <PropertyMainInfoTexts property={property} />
                </div>
            </div>

            <div className={contentWrapperStyle}>{children}</div>
        </div>
    );
};

const innerWrap = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    px: "1.5",
    py: "3",

    md: {
        height: "auto",
        p: "3",
        borderRadius: "1",
        width: "55rem"
    }
});

const propertyWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 3,

    sm: {
        flexDirection: "row"
    }
});

const propertyCoverStyle = css({
    width: "160px",
    height: "80px",
    md: {
        minWidth: "160px"
    }
});

const propertyInfoStyle = css({
    pr: "7",
    md: {
        pr: "4"
    }
});

const pictureStyle = css({
    justifyContent: "center",
    md: {
        mb: 3
    }
});

const contentWrapperStyle = css({
    mt: "4"
});
